import { useUserRoutes } from '@cosuno/authentication-frontend';
import { queryStringToObject } from '@cosuno/utils';
import { Redirect, useLocation } from 'react-router-dom';

interface MarketplaceSuggestionQueryParams {
  bidPackageId?: string;
  sentEmailId?: string;
  subcontractorId?: string;
}

export const MarketplaceSuggestionRedirect = () => {
  const routes = useUserRoutes();
  const location = useLocation();

  const { bidPackageId, ...queryParams } = queryStringToObject<MarketplaceSuggestionQueryParams>(
    location.search,
  );

  if (!bidPackageId) {
    return <Redirect to={routes.agentReverseMarketplace()} />;
  }

  return <Redirect to={routes.reverseMarketplaceBidPackage(bidPackageId, queryParams)} />;
};
